import Alpine from 'alpinejs';

import type { NotificationStore } from '@/stores/notification/notification';

import type { HTMXEvent } from '../types';

export function handleValidationError(response: string) {
    try {
        const { validationError } = JSON.parse(response);

        const toast = Alpine.store('notification') as NotificationStore;
        toast.create({
            type: 'error',
            message: validationError,
        });
    } catch (e) {
        console.error('Failed to parse validation error response', e);
    }
}

// Marks elements whose request failures are non-critical (e.g. background
// prefetches like search suggest) — the global error toast is skipped for them.
export const SILENT_ERRORS_ATTRIBUTE = 'data-silent-errors';

function isSilencedRequest(event: HTMXEvent): boolean {
    const requestSource = event.detail.elt;
    return requestSource instanceof Element && requestSource.closest(`[${SILENT_ERRORS_ATTRIBUTE}]`) !== null;
}

export function htmxGenericErrorHandler(event: HTMXEvent, validationErrorHandler: (response: string) => void) {
    if (isSilencedRequest(event)) {
        return;
    }

    const toast = Alpine.store('notification') as NotificationStore;
    const { status: statusCode, response } = event.detail.xhr;

    switch (statusCode) {
        case 400:
            validationErrorHandler(response);
            break;
        default:
            toast.create({
                type: 'error',
                message: window.translation['unexpected_error'],
            });
    }
}

document.addEventListener('htmx:responseError', (e) => htmxGenericErrorHandler(e as HTMXEvent, handleValidationError));
document.addEventListener('htmx:sendError', (e) => htmxGenericErrorHandler(e as HTMXEvent, handleValidationError));
